(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["masthead-b"] && !Shopify.designMode) return;
  try {
    
    function updateMastheadHeight() {
        const mastheadB = document.querySelector(".masthead-b");
        const usbBlockD = document.querySelector(".usp-block-d");
        const healthWarning = document.querySelector(".header-warning-bar");
        if (mastheadB) {
            document.body.style.setProperty("--masthead-b-height", `${mastheadB.offsetHeight}px`);
        }
        if (healthWarning && usbBlockD) {
            const healthWarningHeight = healthWarning.offsetHeight;
            mastheadB.style.paddingTop = `${healthWarningHeight}px`;
        }
    }
    // Update on load
    document.addEventListener("DOMContentLoaded", updateMastheadHeight);
    // Update on resize with debounce for performance
    let resizeTimer;
    window.addEventListener("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateMastheadHeight, 150);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masthead-d-full"] && !Shopify.designMode) return;
  try {
    
    function updateMastheadWarningOffset() {
        const mastheadD = document.querySelector(".masthead-d__wrapper--full")?.closest(".masthead-d");

        const healthWarning = document.querySelector(".header-warning-bar");

        if (!mastheadD) return;

        // Offset the full Masthead D by the health warning bar height.
        if (healthWarning) {
            mastheadD.style.paddingTop = `${healthWarning.offsetHeight}px`;
        } else {
            mastheadD.style.paddingTop = "";
        }
    }

    document.addEventListener("DOMContentLoaded", updateMastheadWarningOffset);

    let resizeTimer;

    window.addEventListener("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateMastheadWarningOffset, 150);
    });

  } catch(e) { console.error(e); }
})();
})();
